import { Injectable } from '@angular/core';
import { AuthenticationService } from "../authentication.service";
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";
import { debug } from "util";
@Injectable()
export class LoyaltyService {

  constructor(private auth: AuthenticationService, private http: Http) { }
  //--------------Loyalty Member-----------------//
  GetNationality() {
    return this.http
      .get(
        this.auth.baseUrl + "/Loyalty/Get_Nationality",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetMember(filterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/Get_MemberDetail", filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveMember(filteritems: any) {
    if (filteritems.MemberId == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/Loyalty/Save_Member", filteritems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/Loyalty/Update_Member", filteritems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }

  }
  DeleteMember(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/Delete_Member", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Loyalty Member-----------------//
  //--------------Loyalty Card-----------------//
  GetCards(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/Get_CardDetail", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveCard(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/Save_Card", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  generateCardNo() {
    return this.http
      .get(
        this.auth.baseUrl + "/Loyalty/Genarate_CardNo",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deleteCard(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/Delete_Card", filteritems,
        this.auth.getHeader(),
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Loyalty Card-----------------//
  //--------------Loyalty Redemption-----------------//
  GetRedemption(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/Get_RedmeptionDetails", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetGiftVoucherNo() {
    return this.http
      .get(
        this.auth.baseUrl + "/Loyalty/Get_AutoGiftVoucher",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetMemberByCardNo(CardNo: string) {
    return this.http
      .get(
        this.auth.baseUrl + "/Loyalty/Get_MemberbyCardNo?CardNo=" + CardNo,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveRedemption(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/RedemptionInsertUpdation", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  DeleteRedemption(Id: number) {
    return this.http
      .get(
        this.auth.baseUrl + "/Loyalty/DeleteRedemption?id=" + Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetGiftVoucherSettings() {
    return this.http
      .get(
        this.auth.baseUrl + "/Loyalty/Get_GiftVoucherSettings",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_GiftVoucherAmountBySettings() {
    return this.http
      .get(
        this.auth.baseUrl + "/Loyalty/Get_GiftVoucherAmountBySettings",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }


  //--------------Loyalty Redemption-----------------//
  //--------------Point Updation-----------------//
  GetPointsByInvNo(filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/InvoiceCheck", filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_DeptLoyaltySettings(InvNo: any) {
    return this.http
      .get(
        this.auth.baseUrl + "/Loyalty/Get_DeptLoyaltySettings?Invoice=" + InvNo,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SavePointsUpdation(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/PointsInsertUpdation", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deletePointsUpdation(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/PointsDelete", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Point Updation-----------------//
  //--------------Dept Settings-----------------//
  Get_LoyalityDeptSettings(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LoyalityDeptSettings", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_LoyalityDeptSettings(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_LoyalityDeptSettings", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_GiftVoucherSettings(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/Save_GiftVoucherSettings", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Dept Settings-----------------//
  //--------------Nationality Settings-----------------//
  Save_NationSettings(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/Save_NationSettings", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_NationalityList(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/Get_NationalityList", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Delete_Nationality(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/Loyalty/Delete_Nationality", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------Nationality Settings-----------------//
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/Loyalty/loyalty.service.ts